import _ from 'lodash';

export const isAdmin = (email) => _.includes([
  'hubert.bettan@gmail.com',
  'lpe@lespetitesemplettes.com'
], email);